const YearDateUpdate = () => {
    return (
        <>
            {new Date().getFullYear()}
        </>
    )
}

export default YearDateUpdate